module.exports = __webpack_public_path__ + "static/media/QA.d1783d1e.jpg";